export default "__VITE_ASSET__CF44KVsF__"